import React, { useState } from "react";
import FilterShell from "./FilterShell";

const defaultState = {
  status: "",
  startDate: "",
  endDate: "",
  day: "",
};

const STATUS_OPTIONS = [
  "payment-pending",
  "request-pending",
  "rejected",
  "accepted",
  "completed",
  "cancelled",
];

const DAY_OPTIONS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const BookingsFilters = ({ onApply, initial = null }) => {
  const [data, setData] = useState({ ...defaultState, ...(initial || {}) });

  const onChange = (e) =>
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));

  return (
    <FilterShell
      onApply={() => onApply(data)}
      onClear={() => {
        setData(defaultState);
        onApply(defaultState);
      }}
    >
      <div className="col-md-3">
        <label className="form-label">Status</label>
        <select
          name="status"
          className="form-control"
          value={data.status}
          onChange={onChange}
        >
          <option value="">All</option>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>
              {s.replace(/-/g, " ")}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-3">
        <label className="form-label">From</label>
        <input
          type="date"
          name="startDate"
          className="form-control"
          value={data.startDate}
          onChange={onChange}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label">To</label>
        <input
          type="date"
          name="endDate"
          className="form-control"
          value={data.endDate}
          onChange={onChange}
        />
      </div>
      <div className="col-md-2">
        <label className="form-label">Day</label>
        <select
          name="day"
          className="form-control"
          value={data.day}
          onChange={onChange}
        >
          <option value="">Any</option>
          {DAY_OPTIONS.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>
      </div>
    </FilterShell>
  );
};

export default BookingsFilters;
